import React from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import { useNavigate } from 'react-router-dom';
import CandidateList from './CandidateList';
import { Button } from '@/Components/ui/button';
import { Inline } from '@/Components/ui/layout';

export const FindCandidate = () => {
  const navigate = useNavigate();
  return (
    <EmployerLayout>
      <div className="flex flex-col w-full gap-8">
        <Inline justify="end" className="w-full">
          <Button
            variant="outline"
            onClick={() => navigate('/hirewithus/postjob')}
            className="flex items-center gap-2 bg-[#f3f3f4] rounded-xl px-5 py-2.5"
          >
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/8103bbcb4fc48d177a4ce47b728aab0ddb2decffe421fc6e64e0e4238d1ecc00?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
              alt="Icon"
              className="w-[34px] h-[30px]"
            />
            <span className="text-foreground font-semibold text-base px-2.5 py-2.5 border-2 border-[#79a7d5] rounded-[10px]">
              Post Job
            </span>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/7c7da7787896c57a951c679a02375bd00309c34b84ec629d2a50c9a0c27b5e52?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
              alt="Profile Icon"
              className="w-[34px] h-[30px] ml-2"
            />
          </Button>
        </Inline>
        <div className="flex flex-col gap-10 w-full">
          <CandidateList />
        </div>
      </div>
    </EmployerLayout>
  );
};
